var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevops(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1200px",
    height: "557px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5d63cf",
    d: "M 898.5,-0.5 C 913.5,-0.5 928.5,-0.5 943.5,-0.5C 1008.72,5.70098 1065.22,31.0343 1113,75.5C 1106.73,111.177 1100.07,146.843 1093,182.5C 1092.44,183.022 1091.77,183.355 1091,183.5C 1066.37,179.147 1041.87,174.313 1017.5,169C 981.077,137.759 939.077,126.425 891.5,135C 874.48,138.683 858.48,144.849 843.5,153.5C 842.566,152.432 842.232,151.099 842.5,149.5C 846.585,123.24 851.252,97.0728 856.5,71C 856.167,70.5 855.833,70 855.5,69.5C 823.371,63.3077 791.371,56.8077 759.5,50C 801.233,20.5881 847.567,3.75481 898.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#43a3e6",
    d: "M 260.5,-0.5 C 273.167,-0.5 285.833,-0.5 298.5,-0.5C 350.39,3.51905 397.724,20.3524 440.5,50C 408.158,56.6355 375.824,63.4688 343.5,70.5C 349.287,98.8987 354.287,127.232 358.5,155.5C 321.13,132.161 281.13,126.327 238.5,138C 216.908,144.29 197.908,154.956 181.5,170C 156.883,174.824 132.216,179.324 107.5,183.5C 100.334,147.504 93.5002,111.504 87,75.5C 135.932,30.1238 193.765,4.79045 260.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2f8fd",
    d: "M 234.5,49.5 C 235.833,49.5 237.167,49.5 238.5,49.5C 240.371,59.523 242.371,69.523 244.5,79.5C 242.879,83.1826 241.545,83.1826 240.5,79.5C 237.331,84.1179 232.998,85.6179 227.5,84C 222.434,80.9989 220.101,76.4989 220.5,70.5C 220.383,63.7505 223.716,60.0839 230.5,59.5C 232.593,59.4858 234.426,60.1524 236,61.5C 235.965,57.4786 235.465,53.4786 234.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2f2fb",
    d: "M 928.5,53.5 C 939.185,52.1904 944.519,56.8571 944.5,67.5C 938.167,67.5 931.833,67.5 925.5,67.5C 926.682,74.2668 930.682,76.7668 937.5,75C 938.931,74.5348 940.097,73.7014 941,72.5C 942.767,75.1571 941.934,76.9904 938.5,78C 925.168,79.6661 919.668,73.8328 922,60.5C 923.694,57.6424 925.861,55.309 928.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efeffa",
    d: "M 985.5,53.5 C 987.09,53.6282 988.423,54.2949 989.5,55.5C 986.025,65.9265 982.358,76.2598 978.5,86.5C 977.5,86 976.5,85.5 975.5,85C 979.133,74.6016 982.466,64.1016 985.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f9fd",
    d: "M 256.5,55.5 C 266.589,54.1904 271.922,58.5237 272.5,68.5C 266.155,68.6527 259.822,68.986 253.5,69.5C 254.392,75.9525 258.059,78.4525 264.5,77C 266.421,76.6397 268.088,75.8064 269.5,74.5C 270.308,74.8076 270.975,75.3076 271.5,76C 265.138,81.7748 258.638,81.9414 252,76.5C 247.499,68.0199 248.999,61.0199 256.5,55.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2f2fb",
    d: "M 907.5,45.5 C 908.833,45.5 910.167,45.5 911.5,45.5C 913.272,56.4694 914.939,67.4694 916.5,78.5C 915.167,78.5 913.833,78.5 912.5,78.5C 912.649,77.448 912.483,76.448 912,75.5C 908.746,80.2227 904.246,81.7227 898.5,80C 892.424,74.2663 890.924,67.4329 894,59.5C 898.133,55.1 902.8,54.4333 908,57.5C 908.357,53.4896 908.19,49.4896 907.5,45.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6268d0",
    d: "M 929.5,56.5 C 936.073,55.4274 939.74,58.0941 940.5,64.5C 935.5,64.5 930.5,64.5 925.5,64.5C 925.343,63.1266 925.51,61.7932 926,60.5C 927.376,59.2949 928.542,57.9616 929.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2f2fb",
    d: "M 953.5,55.5 C 954.833,55.5 956.167,55.5 957.5,55.5C 957.281,56.675 957.614,57.675 958.5,58.5C 970.031,56.197 974.864,60.8637 973,72.5C 968.886,83.601 962.386,85.2676 953.5,77.5C 951.906,80.9855 951.24,84.6521 951.5,88.5C 950.167,88.5 948.833,88.5 947.5,88.5C 949.338,77.4783 951.338,66.4783 953.5,55.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4aa5e7",
    d: "M 257.5,58.5 C 264.002,57.5625 267.669,60.2292 268.5,66.5C 263.5,66.5 258.5,66.5 253.5,66.5C 253.343,65.1266 253.51,63.7932 254,62.5C 255.376,61.2949 256.542,59.9616 257.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6166d0",
    d: "M 900.5,58.5 C 904.192,57.9712 907.358,58.9712 910,61.5C 910.811,65.4963 911.144,69.4963 911,73.5C 905.264,79.2824 900.598,78.6157 897,71.5C 895.539,66.3265 896.706,61.9932 900.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5e65d0",
    d: "M 958.5,60.5 C 967.778,59.3759 971.278,63.3759 969,72.5C 965.632,79.1747 960.965,80.1747 955,75.5C 954.575,71.1305 954.908,66.7972 956,62.5C 956.995,61.9341 957.828,61.2674 958.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#48a4e6",
    d: "M 229.5,62.5 C 232.862,62.0695 235.695,63.0695 238,65.5C 238.998,69.4726 239.331,73.4726 239,77.5C 233.309,83.2925 228.643,82.6258 225,75.5C 223.243,69.8252 224.743,65.4918 229.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2f8fd",
    d: "M 200.5,67.5 C 211.265,67.4312 216.431,72.7646 216,83.5C 213.158,91.1729 207.658,94.0062 199.5,92C 193.412,87.7481 191.246,81.9148 193,74.5C 194.742,71.2543 197.242,68.921 200.5,67.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f3fb",
    d: "M 997.5,68.5 C 1011,69.4823 1015.17,76.149 1010,88.5C 1003.33,96.5 996.667,96.5 990,88.5C 986.649,79.5497 989.149,72.883 997.5,68.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#47a4e6",
    d: "M 199.5,71.5 C 207.088,70.258 211.421,73.4247 212.5,81C 211.893,87.8077 208.227,90.4744 201.5,89C 195.739,83.6547 195.073,77.8214 199.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5e64cf",
    d: "M 997.5,72.5 C 1007.04,72.2011 1010.2,76.5345 1007,85.5C 1004.77,89.8608 1001.27,91.3608 996.5,90C 992.672,86.7355 991.505,82.5689 993,77.5C 994.707,75.9625 996.207,74.2959 997.5,72.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#44a3e6",
    d: "M 468.5,75.5 C 469.873,75.3433 471.207,75.51 472.5,76C 509.018,108.686 545.685,141.186 582.5,173.5C 549.192,203.138 515.859,232.805 482.5,262.5C 453.518,237.353 424.685,212.019 396,186.5C 390.101,155.841 384.268,125.174 378.5,94.5C 379.025,93.8076 379.692,93.3076 380.5,93C 410.031,87.4714 439.364,81.638 468.5,75.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5c63cf",
    d: "M 415.5,356.5 C 414.209,356.737 413.209,356.404 412.5,355.5C 414.142,354.197 415.809,352.864 417.5,351.5C 420.089,350.581 422.089,348.914 423.5,346.5C 424.167,345.167 425.167,344.167 426.5,343.5C 429.089,342.581 431.089,340.914 432.5,338.5C 433.167,337.167 434.167,336.167 435.5,335.5C 438.089,334.581 440.089,332.914 441.5,330.5C 442.167,329.167 443.167,328.167 444.5,327.5C 446.749,326.92 448.415,325.587 449.5,323.5C 450.167,322.167 451.167,321.167 452.5,320.5C 455.089,319.581 457.089,317.914 458.5,315.5C 459.167,314.167 460.167,313.167 461.5,312.5C 464.089,311.581 466.089,309.914 467.5,307.5C 468.167,306.167 469.167,305.167 470.5,304.5C 473.089,303.581 475.089,301.914 476.5,299.5C 477.167,298.167 478.167,297.167 479.5,296.5C 481.749,295.92 483.415,294.587 484.5,292.5C 485.5,290.833 486.833,289.5 488.5,288.5C 490.749,287.92 492.415,286.587 493.5,284.5C 494.167,283.167 495.167,282.167 496.5,281.5C 499.089,280.581 501.089,278.914 502.5,276.5C 503.167,275.167 504.167,274.167 505.5,273.5C 508.089,272.581 510.089,270.914 511.5,268.5C 512.167,267.167 513.167,266.167 514.5,265.5C 517.089,264.581 519.089,262.914 520.5,260.5C 521.167,259.167 522.167,258.167 523.5,257.5C 525.749,256.92 527.415,255.587 528.5,253.5C 529.5,251.833 530.833,250.5 532.5,249.5C 534.749,248.92 536.415,247.587 537.5,245.5C 538.167,244.167 539.167,243.167 540.5,242.5C 543.089,241.581 545.089,239.914 546.5,237.5C 547.167,236.167 548.167,235.167 549.5,234.5C 552.089,233.581 554.089,231.914 555.5,229.5C 556.167,228.167 557.167,227.167 558.5,226.5C 560.749,225.92 562.415,224.587 563.5,222.5C 564.5,220.833 565.833,219.5 567.5,218.5C 569.749,217.92 571.415,216.587 572.5,214.5C 573.167,213.167 574.167,212.167 575.5,211.5C 578.089,210.581 580.089,208.914 581.5,206.5C 582.167,205.167 583.167,204.167 584.5,203.5C 587.089,202.581 589.089,200.914 590.5,198.5C 591.167,197.167 592.167,196.167 593.5,195.5C 596.089,194.581 598.089,192.914 599.5,190.5C 600.167,189.167 601.167,188.167 602.5,187.5C 604.749,186.92 606.415,185.587 607.5,183.5C 608.5,181.833 609.833,180.5 611.5,179.5C 613.749,178.92 615.415,177.587 616.5,175.5C 617.167,174.167 618.167,173.167 619.5,172.5C 622.089,171.581 624.089,169.914 625.5,167.5C 626.167,166.167 627.167,165.167 628.5,164.5C 631.089,163.581 633.089,161.914 634.5,159.5C 635.167,158.167 636.167,157.167 637.5,156.5C 640.089,155.581 642.089,153.914 643.5,151.5C 644.167,150.167 645.167,149.167 646.5,148.5C 648.749,147.92 650.415,146.587 651.5,144.5C 652.167,143.167 653.167,142.167 654.5,141.5C 657.089,140.581 659.089,138.914 660.5,136.5C 661.167,135.167 662.167,134.167 663.5,133.5C 666.089,132.581 668.089,130.914 669.5,128.5C 670.167,127.167 671.167,126.167 672.5,125.5C 675.089,124.581 677.089,122.914 678.5,120.5C 679.167,119.167 680.167,118.167 681.5,117.5C 683.749,116.92 685.415,115.587 686.5,113.5C 687.5,111.833 688.833,110.5 690.5,109.5C 692.749,108.92 694.415,107.587 695.5,105.5C 696.167,104.167 697.167,103.167 698.5,102.5C 701.089,101.581 703.089,99.914 704.5,97.5C 705.167,96.1667 706.167,95.1667 707.5,94.5C 710.089,93.5806 712.089,91.914 713.5,89.5C 714.167,88.1667 715.167,87.1667 716.5,86.5C 719.089,85.5806 721.089,83.914 722.5,81.5C 724.278,78.5509 726.778,76.5509 730,75.5C 760.218,81.3103 790.385,87.3103 820.5,93.5C 820.833,94 821.167,94.5 821.5,95C 815.933,125.575 810.099,156.075 804,186.5C 708.982,271.019 613.815,355.352 518.5,439.5C 514.898,409.941 512.231,380.275 510.5,350.5C 478.83,352.453 447.163,354.453 415.5,356.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f4fb",
    d: "M 1019.5,77.5 C 1020.5,77.4142 1021.33,77.7476 1022,78.5C 1022.17,79.8333 1022.33,81.1667 1022.5,82.5C 1021.58,88.1683 1021.08,93.835 1021,99.5C 1026.23,94.8051 1031.73,90.4718 1037.5,86.5C 1038.5,86.8333 1039.17,87.5 1039.5,88.5C 1032.01,95.1582 1024.34,101.658 1016.5,108C 1012.51,110.284 1008.84,109.951 1005.5,107C 1007.14,105.199 1008.97,105.032 1011,106.5C 1012.66,105.516 1014.32,104.516 1016,103.5C 1017.63,94.8855 1018.79,86.2189 1019.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eef6fc",
    d: "M 177.5,79.5 C 179.833,79.5 182.167,79.5 184.5,79.5C 184.67,80.8221 184.337,81.9887 183.5,83C 174.261,83.2952 171.428,87.7952 175,96.5C 177.955,100.277 181.788,101.443 186.5,100C 188.414,98.5867 189.747,96.7534 190.5,94.5C 191.325,93.6143 192.325,93.281 193.5,93.5C 192.72,100.611 188.72,104.278 181.5,104.5C 173.954,103.285 169.954,98.7853 169.5,91C 170.327,85.8328 172.994,81.9994 177.5,79.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9999e0",
    d: "M 722.5,81.5 C 721.089,83.914 719.089,85.5806 716.5,86.5C 717.911,84.086 719.911,82.4194 722.5,81.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9696e0",
    d: "M 713.5,89.5 C 712.089,91.914 710.089,93.5806 707.5,94.5C 708.911,92.086 710.911,90.4194 713.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9797e0",
    d: "M 704.5,97.5 C 703.089,99.914 701.089,101.581 698.5,102.5C 699.911,100.086 701.911,98.4194 704.5,97.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#43a3e6",
    d: "M -0.5,295.5 C -0.5,283.833 -0.5,272.167 -0.5,260.5C 3.73791,202.105 24.0712,150.105 60.5,104.5C 68.8013,142.291 76.468,180.291 83.5,218.5C 105.513,214.631 127.513,210.631 149.5,206.5C 150.167,206.833 150.833,207.167 151.5,207.5C 125.678,256.624 126.511,305.29 154,353.5C 157.946,359.779 162.279,365.779 167,371.5C 172.995,402.968 178.828,434.468 184.5,466C 184.415,467.107 184.081,468.107 183.5,469C 153.2,475.194 122.867,480.861 92.5,486C 37.0338,434.566 6.03385,371.066 -0.5,295.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5d63cf",
    d: "M 1151.5,120.5 C 1151.43,122.027 1152.09,123.027 1153.5,123.5C 1153.43,125.027 1154.09,126.027 1155.5,126.5C 1155.43,128.027 1156.09,129.027 1157.5,129.5C 1180.21,164.615 1194.21,202.949 1199.5,244.5C 1199.5,266.833 1199.5,289.167 1199.5,311.5C 1189.87,380.909 1159.21,439.076 1107.5,486C 1076.88,480.942 1046.38,475.109 1016,468.5C 1021.12,436.132 1026.78,403.799 1033,371.5C 1035.7,367.975 1038.53,364.642 1041.5,361.5C 1042.91,361.027 1043.57,360.027 1043.5,358.5C 1044.91,358.027 1045.57,357.027 1045.5,355.5C 1072.89,307.762 1074.56,259.095 1050.5,209.5C 1050.5,208.167 1051.17,207.5 1052.5,207.5C 1073.87,211.077 1095.21,214.577 1116.5,218C 1123.97,180.14 1131.64,142.307 1139.5,104.5C 1143.98,109.467 1147.98,114.8 1151.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9998e0",
    d: "M 695.5,105.5 C 694.415,107.587 692.749,108.92 690.5,109.5C 691.585,107.413 693.251,106.08 695.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9695df",
    d: "M 686.5,113.5 C 685.415,115.587 683.749,116.92 681.5,117.5C 682.585,115.413 684.251,114.08 686.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1b1e8",
    d: "M 1151.5,120.5 C 1152.91,120.973 1153.57,121.973 1153.5,123.5C 1152.09,123.027 1151.43,122.027 1151.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9797e0",
    d: "M 678.5,120.5 C 677.089,122.914 675.089,124.581 672.5,125.5C 673.911,123.086 675.911,121.419 678.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f9fd",
    d: "M 447.5,124.5 C 450.578,125.664 450.912,127.164 448.5,129C 461.25,132.009 463.75,138.842 456,149.5C 446.71,156.268 440.043,154.268 436,143.5C 433.333,146.167 430.667,148.833 428,151.5C 427.167,150.667 426.333,149.833 425.5,149C 433.041,140.963 440.374,132.796 447.5,124.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1b1e8",
    d: "M 1153.5,123.5 C 1154.91,123.973 1155.57,124.973 1155.5,126.5C 1154.09,126.027 1153.43,125.027 1153.5,123.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1b1e8",
    d: "M 1155.5,126.5 C 1156.91,126.973 1157.57,127.973 1157.5,129.5C 1156.09,129.027 1155.43,128.027 1155.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#49a5e6",
    d: "M 446.5,131.5 C 457.73,134.024 459.397,139.524 451.5,148C 443.048,151.202 438.881,148.368 439,139.5C 441.705,136.964 444.205,134.297 446.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9595df",
    d: "M 669.5,128.5 C 668.089,130.914 666.089,132.581 663.5,133.5C 664.911,131.086 666.911,129.419 669.5,128.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f9fd",
    d: "M 474.5,137.5 C 476.686,137.511 477.519,138.511 477,140.5C 470.167,148 463.333,155.5 456.5,163C 454.333,163.5 453.5,162.667 454,160.5C 461.041,152.962 467.874,145.296 474.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9797e0",
    d: "M 660.5,136.5 C 659.089,138.914 657.089,140.581 654.5,141.5C 655.911,139.086 657.911,137.419 660.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9897e0",
    d: "M 651.5,144.5 C 650.415,146.587 648.749,147.92 646.5,148.5C 647.585,146.413 649.251,145.08 651.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#acade6",
    d: "M 842.5,149.5 C 842.232,151.099 842.566,152.432 843.5,153.5C 843.217,154.289 842.717,154.956 842,155.5C 841.211,153.288 841.378,151.288 842.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2f8fd",
    d: "M 475.5,153.5 C 488.287,155.724 491.12,162.057 484,172.5C 481,175.5 478,178.5 475,181.5C 473.242,180.531 472.742,179.364 473.5,178C 462.871,175.098 460.871,169.431 467.5,161C 474.444,159.891 478.944,162.725 481,169.5C 485.74,165.508 485.573,161.675 480.5,158C 478.5,157.167 476.5,156.333 474.5,155.5C 474.863,154.817 475.196,154.15 475.5,153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9999e0",
    d: "M 643.5,151.5 C 642.089,153.914 640.089,155.581 637.5,156.5C 638.911,154.086 640.911,152.419 643.5,151.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9696e0",
    d: "M 634.5,159.5 C 633.089,161.914 631.089,163.581 628.5,164.5C 629.911,162.086 631.911,160.419 634.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4da6e7",
    d: "M 469.5,163.5 C 477.663,164.116 479.997,167.949 476.5,175C 471.044,176.105 467.711,173.938 466.5,168.5C 467.092,166.577 468.092,164.911 469.5,163.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0f7fd",
    d: "M 495.5,169.5 C 498.694,169.176 499.694,170.342 498.5,173C 504.017,173.903 507.684,176.903 509.5,182C 509.375,183.627 508.875,185.127 508,186.5C 504.285,191.259 500.118,195.593 495.5,199.5C 493.899,198.965 493.399,197.965 494,196.5C 498.228,191.943 502.061,187.11 505.5,182C 503.441,176.933 499.774,175.266 494.5,177C 491.536,180.966 488.203,184.633 484.5,188C 483.035,188.601 482.035,188.101 481.5,186.5C 486.19,180.814 490.857,175.147 495.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9897e0",
    d: "M 625.5,167.5 C 624.089,169.914 622.089,171.581 619.5,172.5C 620.911,170.086 622.911,168.419 625.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9a9ae1",
    d: "M 616.5,175.5 C 615.415,177.587 613.749,178.92 611.5,179.5C 612.585,177.413 614.251,176.08 616.5,175.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9796e0",
    d: "M 607.5,183.5 C 606.415,185.587 604.749,186.92 602.5,187.5C 603.585,185.413 605.251,184.08 607.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9999e0",
    d: "M 599.5,190.5 C 598.089,192.914 596.089,194.581 593.5,195.5C 594.911,193.086 596.911,191.419 599.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eeeefa",
    d: "M 672.5,200.5 C 678.16,199.831 682.827,201.664 686.5,206C 682.301,210.534 677.801,214.701 673,218.5C 672.312,219.332 672.479,219.998 673.5,220.5C 681.334,223.328 686,220.661 687.5,212.5C 688.5,212.5 689.5,212.5 690.5,212.5C 689.842,220.492 685.508,224.825 677.5,225.5C 666.308,222.781 662.808,216.114 667,205.5C 668.812,203.7 670.645,202.033 672.5,200.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9696e0",
    d: "M 590.5,198.5 C 589.089,200.914 587.089,202.581 584.5,203.5C 585.911,201.086 587.911,199.419 590.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6066d0",
    d: "M 672.5,204.5 C 675.807,204.063 678.807,204.73 681.5,206.5C 678.442,210.525 674.775,213.858 670.5,216.5C 667.503,211.815 668.17,207.815 672.5,204.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bfc0ec",
    d: "M 1052.5,207.5 C 1051.17,207.5 1050.5,208.167 1050.5,209.5C 1049.73,208.828 1049.07,207.995 1048.5,207C 1050.07,206.235 1051.4,206.402 1052.5,207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9797e0",
    d: "M 581.5,206.5 C 580.089,208.914 578.089,210.581 575.5,211.5C 576.911,209.086 578.911,207.419 581.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9897e0",
    d: "M 572.5,214.5 C 571.415,216.587 569.749,217.92 567.5,218.5C 568.585,216.413 570.251,215.08 572.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2f2fb",
    d: "M 653.5,217.5 C 655.167,217.5 656.833,217.5 658.5,217.5C 658.5,218.5 658.5,219.5 658.5,220.5C 652.918,220.597 649.752,223.264 649,228.5C 649.739,229.574 650.739,230.241 652,230.5C 655.75,228.569 659.583,226.902 663.5,225.5C 669.488,227.638 670.988,231.638 668,237.5C 664.787,241.524 660.62,243.524 655.5,243.5C 655.5,242.167 655.5,240.833 655.5,239.5C 661.059,240.392 664.726,238.225 666.5,233C 665.942,230.942 664.609,229.775 662.5,229.5C 659.282,231.524 655.782,232.857 652,233.5C 646.447,232.938 644.447,229.938 646,224.5C 648.015,221.588 650.515,219.255 653.5,217.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9695df",
    d: "M 563.5,222.5 C 562.415,224.587 560.749,225.92 558.5,226.5C 559.585,224.413 561.251,223.08 563.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9797e0",
    d: "M 555.5,229.5 C 554.089,231.914 552.089,233.581 549.5,234.5C 550.911,232.086 552.911,230.419 555.5,229.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1f1fb",
    d: "M 635.5,233.5 C 637.655,233.372 639.655,233.872 641.5,235C 645.45,239.072 649.283,243.238 653,247.5C 653.829,250.674 652.829,251.674 650,250.5C 647.966,257.266 643.466,260.099 636.5,259C 629.961,250.534 631.961,244.701 642.5,241.5C 638.759,236.205 634.926,236.205 631,241.5C 629.991,243.025 629.491,244.692 629.5,246.5C 628.5,246.5 627.5,246.5 626.5,246.5C 626.776,240.281 629.776,235.948 635.5,233.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6d6d6d",
    d: "M 843.5,236.5 C 877.13,234.3 893.63,249.966 893,283.5C 888.23,305.095 874.73,316.428 852.5,317.5C 824.59,314.761 811.09,299.427 812,271.5C 814.693,252.647 825.193,240.981 843.5,236.5 Z M 849.5,251.5 C 868.006,252.789 876.506,262.789 875,281.5C 871.691,296.239 862.524,302.739 847.5,301C 837.016,298.18 831.182,291.346 830,280.5C 828.606,265.236 835.106,255.569 849.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b6b6b",
    d: "M 192.5,237.5 C 205.504,237.333 218.504,237.5 231.5,238C 257.351,244.55 267.851,261.05 263,287.5C 258.123,303.041 247.623,312.207 231.5,315C 218.504,315.5 205.504,315.667 192.5,315.5C 192.5,289.5 192.5,263.5 192.5,237.5 Z M 209.5,252.5 C 219.275,251.524 228.608,253.024 237.5,257C 247.1,266.487 248.934,277.32 243,289.5C 238.951,295.866 233.117,299.366 225.5,300C 220.177,300.499 214.844,300.666 209.5,300.5C 209.5,284.5 209.5,268.5 209.5,252.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9595df",
    d: "M 546.5,237.5 C 545.089,239.914 543.089,241.581 540.5,242.5C 541.911,240.086 543.911,238.419 546.5,237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6167d0",
    d: "M 640.5,244.5 C 646,243.831 648.167,246.165 647,251.5C 644.947,255.292 641.781,256.458 637.5,255C 634.808,250.528 635.808,247.028 640.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9a9ae1",
    d: "M 537.5,245.5 C 536.415,247.587 534.749,248.92 532.5,249.5C 533.585,247.413 535.251,246.08 537.5,245.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efeffa",
    d: "M 614.5,251.5 C 620.084,251.082 624.751,252.915 628.5,257C 624.095,261.283 619.595,265.45 615,269.5C 614.312,270.332 614.479,270.998 615.5,271.5C 623.192,273.99 627.859,271.323 629.5,263.5C 630.5,263.5 631.5,263.5 632.5,263.5C 630.283,274.227 623.95,278.06 613.5,275C 603.877,266.589 604.21,258.755 614.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2f2fb",
    d: "M 1126.5,253.5 C 1140.21,252.367 1145.38,258.367 1142,271.5C 1136.44,277.924 1129.94,279.091 1122.5,275C 1118.7,270.909 1117.53,266.076 1119,260.5C 1121.01,257.588 1123.51,255.255 1126.5,253.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6167d0",
    d: "M 613.5,255.5 C 616.187,255.336 618.854,255.503 621.5,256C 622.308,256.308 622.975,256.808 623.5,257.5C 620.064,261.057 616.397,264.391 612.5,267.5C 611.914,267.291 611.414,266.957 611,266.5C 609.812,262.259 610.645,258.592 613.5,255.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9897e0",
    d: "M 528.5,253.5 C 527.415,255.587 525.749,256.92 523.5,257.5C 524.585,255.413 526.251,254.08 528.5,253.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6d6d6d",
    d: "M 328.5,284.5 C 328.5,286.833 328.5,289.167 328.5,291.5C 314.656,291.171 300.99,291.504 287.5,292.5C 290.912,301.713 297.579,305.547 307.5,304C 311.625,303.296 315.125,301.463 318,298.5C 320.868,301.736 323.368,305.236 325.5,309C 318.591,314.693 310.591,317.527 301.5,317.5C 282.433,316.433 272.433,306.433 271.5,287.5C 273.561,264.949 285.895,255.116 308.5,258C 321.341,262.186 328.008,271.02 328.5,284.5 Z M 299.5,269.5 C 307.584,269.587 312.25,273.587 313.5,281.5C 304.808,281.831 296.141,281.498 287.5,280.5C 289.483,274.527 293.483,270.861 299.5,269.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b6b6b",
    d: "M 920.5,310.5 C 920.217,309.711 919.717,309.044 919,308.5C 918.5,317.827 918.334,327.161 918.5,336.5C 913.833,336.5 909.167,336.5 904.5,336.5C 904.5,310.833 904.5,285.167 904.5,259.5C 909.167,259.5 913.833,259.5 918.5,259.5C 918.338,261.527 918.505,263.527 919,265.5C 919.717,264.956 920.217,264.289 920.5,263.5C 922.819,260.706 925.819,258.872 929.5,258C 950.748,256.074 961.415,265.908 961.5,287.5C 960.678,309.172 949.678,318.672 928.5,316C 925.244,314.884 922.578,313.051 920.5,310.5 Z M 927.5,271.5 C 938.556,270.719 944.556,275.885 945.5,287C 944.262,298.938 937.929,303.938 926.5,302C 923.898,301.117 921.731,299.617 920,297.5C 919.333,290.5 919.333,283.5 920,276.5C 922.426,274.548 924.926,272.881 927.5,271.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6f6f6f",
    d: "M 983.5,257.5 C 994.701,255.743 1004.87,258.076 1014,264.5C 1014.67,265.5 1014.67,266.5 1014,267.5C 1012.4,270.378 1010.57,273.044 1008.5,275.5C 1001.56,270.011 993.889,268.511 985.5,271C 982.659,274.159 983.326,276.492 987.5,278C 993.9,279.413 1000.23,281.08 1006.5,283C 1015.48,287.473 1018.65,294.64 1016,304.5C 1010.82,313.761 1002.82,318.095 992,317.5C 981.992,317.719 973.492,314.386 966.5,307.5C 968.354,303.779 970.687,300.446 973.5,297.5C 980.854,303.451 989.187,305.618 998.5,304C 1001.36,302.214 1002.03,299.881 1000.5,297C 992.933,294.418 985.267,292.084 977.5,290C 968.662,284.82 966.162,277.32 970,267.5C 973.369,262.573 977.869,259.239 983.5,257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f65d0",
    d: "M 1127.5,257.5 C 1138.46,256.612 1141.8,261.112 1137.5,271C 1132.47,274.491 1127.63,274.325 1123,270.5C 1121.75,267.923 1121.42,265.257 1122,262.5C 1123.73,260.598 1125.56,258.931 1127.5,257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b9b9b9",
    d: "M 347.5,259.5 C 341.974,259.179 336.64,259.512 331.5,260.5C 330.957,260.44 330.624,260.107 330.5,259.5C 336.32,258.184 341.987,258.184 347.5,259.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b8b8b8",
    d: "M 375.5,259.5 C 380.975,258.511 386.642,258.178 392.5,258.5C 392.737,259.791 392.404,260.791 391.5,261.5C 386.604,259.554 381.271,258.887 375.5,259.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6e6e6e",
    d: "M 347.5,259.5 C 352.218,271.474 357.051,283.474 362,295.5C 366.41,283.433 370.91,271.433 375.5,259.5C 381.271,258.887 386.604,259.554 391.5,261.5C 384.702,279.222 377.702,296.889 370.5,314.5C 364.537,315.496 358.537,315.829 352.5,315.5C 345.7,297.1 338.7,278.767 331.5,260.5C 336.64,259.512 341.974,259.179 347.5,259.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b2b2b2",
    d: "M 920.5,263.5 C 920.217,264.289 919.717,264.956 919,265.5C 918.505,263.527 918.338,261.527 918.5,259.5C 913.833,259.5 909.167,259.5 904.5,259.5C 904.5,285.167 904.5,310.833 904.5,336.5C 903.502,310.672 903.169,284.672 903.5,258.5C 908.833,258.5 914.167,258.5 919.5,258.5C 919.216,260.415 919.549,262.081 920.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2f2fb",
    d: "M 590.5,260.5 C 591.496,260.414 592.329,260.748 593,261.5C 599.46,269.629 606.294,277.463 613.5,285C 612.457,286.976 611.123,287.476 609.5,286.5C 602.852,278.685 596.019,271.018 589,263.5C 588.761,262.212 589.261,261.212 590.5,260.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9999e0",
    d: "M 520.5,260.5 C 519.089,262.914 517.089,264.581 514.5,265.5C 515.911,263.086 517.911,261.419 520.5,260.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9696e0",
    d: "M 511.5,268.5 C 510.089,270.914 508.089,272.581 505.5,273.5C 506.911,271.086 508.911,269.419 511.5,268.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0f0fa",
    d: "M 585.5,277.5 C 590.983,277.076 595.317,279.076 598.5,283.5C 594.008,287.823 589.341,291.99 584.5,296C 590.106,299.861 594.939,299.027 599,293.5C 599.49,292.207 599.657,290.873 599.5,289.5C 600.5,289.5 601.5,289.5 602.5,289.5C 601.87,297.463 597.537,301.797 589.5,302.5C 579.919,300.364 576.085,294.364 578,284.5C 579.742,281.254 582.242,278.921 585.5,277.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9797e0",
    d: "M 502.5,276.5 C 501.089,278.914 499.089,280.581 496.5,281.5C 497.911,279.086 499.911,277.419 502.5,276.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f9fd",
    d: "M 49.5,281.5 C 60.4793,282.72 71.4793,283.72 82.5,284.5C 82.5,285.833 82.5,287.167 82.5,288.5C 78.4249,288.002 74.4249,288.002 70.5,288.5C 73.5632,293.826 72.8965,298.659 68.5,303C 63.9534,304.545 59.2867,304.879 54.5,304C 46.5162,299.108 45.5162,293.108 51.5,286C 49.8934,284.951 49.2267,283.451 49.5,281.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6167d0",
    d: "M 584.5,281.5 C 588.302,280.88 591.635,281.714 594.5,284C 590.644,287.357 586.644,290.524 582.5,293.5C 579.433,288.841 580.099,284.841 584.5,281.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4ba5e7",
    d: "M 54.5,285.5 C 58.5092,285.858 62.5092,286.358 66.5,287C 70.4227,291.261 70.4227,295.594 66.5,300C 61.116,302.421 56.2827,301.588 52,297.5C 50.888,293.019 51.7213,289.019 54.5,285.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9998e0",
    d: "M 493.5,284.5 C 492.415,286.587 490.749,287.92 488.5,288.5C 489.585,286.413 491.251,285.08 493.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efeffa",
    d: "M 1112.5,283.5 C 1123.5,283.5 1134.5,283.5 1145.5,283.5C 1145.5,284.833 1145.5,286.167 1145.5,287.5C 1144.45,287.351 1143.45,287.517 1142.5,288C 1147.83,293.333 1147.83,298.667 1142.5,304C 1137.32,306.851 1131.99,307.185 1126.5,305C 1121.78,301.746 1120.28,297.246 1122,291.5C 1122.47,290.069 1123.3,288.903 1124.5,288C 1120.51,287.501 1116.51,287.334 1112.5,287.5C 1112.5,286.167 1112.5,284.833 1112.5,283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f65d0",
    d: "M 1127.5,287.5 C 1131.51,287.334 1135.51,287.501 1139.5,288C 1142.39,290.909 1143.23,294.409 1142,298.5C 1137.76,302.583 1132.92,303.417 1127.5,301C 1123.55,296.503 1123.55,292.003 1127.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b7b7b7",
    d: "M 328.5,284.5 C 329.473,286.948 329.806,289.615 329.5,292.5C 315.5,292.5 301.5,292.5 287.5,292.5C 300.99,291.504 314.656,291.171 328.5,291.5C 328.5,289.167 328.5,286.833 328.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2f2fb",
    d: "M 569.5,290.5 C 570.452,291.452 571.452,292.452 572.5,293.5C 569.614,295.514 568.447,298.18 569,301.5C 572.333,305.5 575.667,309.5 579,313.5C 579.601,314.965 579.101,315.965 577.5,316.5C 572.011,310.842 566.677,305.009 561.5,299C 562.917,296.174 564.417,296.007 566,298.5C 566.502,295.512 567.669,292.845 569.5,290.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9796e0",
    d: "M 484.5,292.5 C 483.415,294.587 481.749,295.92 479.5,296.5C 480.585,294.413 482.251,293.08 484.5,292.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#48a4e6",
    d: "M 787.5,355.5 C 786.791,356.404 785.791,356.737 784.5,356.5C 755.807,354.857 727.14,352.857 698.5,350.5C 695.713,349.523 692.713,349.19 689.5,349.5C 689.5,350.5 689.5,351.5 689.5,352.5C 687.665,380.52 685.498,408.52 683,436.5C 682.751,437.624 682.251,438.624 681.5,439.5C 661.141,421.471 640.808,403.471 620.5,385.5C 653.028,355.473 686.028,325.973 719.5,297C 721.976,297.747 724.309,299.081 726.5,301C 746.73,319.403 767.063,337.57 787.5,355.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9797e0",
    d: "M 476.5,299.5 C 475.089,301.914 473.089,303.581 470.5,304.5C 471.911,302.086 473.911,300.419 476.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1b1b1",
    d: "M 920.5,310.5 C 919.833,319.167 919.167,327.833 918.5,336.5C 918.334,327.161 918.5,317.827 919,308.5C 919.717,309.044 920.217,309.711 920.5,310.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9696e0",
    d: "M 467.5,307.5 C 466.089,309.914 464.089,311.581 461.5,312.5C 462.911,310.086 464.911,308.419 467.5,307.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f9fd",
    d: "M 68.5,311.5 C 69.5,311.5 70.5,311.5 71.5,311.5C 71.5,312.833 71.5,314.167 71.5,315.5C 65.3811,316.131 59.3811,317.297 53.5,319C 50.3717,324.264 51.705,328.097 57.5,330.5C 63.1591,329.39 68.8257,328.39 74.5,327.5C 74.5,328.833 74.5,330.167 74.5,331.5C 66.7662,332.462 59.0995,333.795 51.5,335.5C 50.5713,334.311 50.238,332.978 50.5,331.5C 51.552,331.649 52.552,331.483 53.5,331C 49.2106,327.465 47.7106,322.965 49,317.5C 49.9025,316.299 51.0692,315.465 52.5,315C 58.0289,314.114 63.3622,312.947 68.5,311.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0f0fa",
    d: "M 1127.5,311.5 C 1139.19,311.353 1144.36,317.02 1143,328.5C 1139.37,333.996 1134.21,336.33 1127.5,335.5C 1128.75,329.156 1130.09,322.823 1131.5,316.5C 1127.49,315.41 1124.33,316.744 1122,320.5C 1122.08,324.229 1121.91,327.896 1121.5,331.5C 1119.02,329.909 1118.02,327.575 1118.5,324.5C 1118.78,318.228 1121.78,313.895 1127.5,311.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6167d0",
    d: "M 1133.5,316.5 C 1139.57,317.76 1141.74,321.427 1140,327.5C 1137.86,330.321 1135.03,331.654 1131.5,331.5C 1132.33,326.523 1132.99,321.523 1133.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9797e0",
    d: "M 458.5,315.5 C 457.089,317.914 455.089,319.581 452.5,320.5C 453.911,318.086 455.911,316.419 458.5,315.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9897e0",
    d: "M 449.5,323.5 C 448.415,325.587 446.749,326.92 444.5,327.5C 445.585,325.413 447.251,324.08 449.5,323.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9999e0",
    d: "M 441.5,330.5 C 440.089,332.914 438.089,334.581 435.5,335.5C 436.911,333.086 438.911,331.419 441.5,330.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eef6fc",
    d: "M 82.5,335.5 C 86.1612,335.35 87.1612,336.85 85.5,340C 81.7071,340.487 80.7071,338.987 82.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8fbfe",
    d: "M 74.5,338.5 C 75.5,338.5 76.5,338.5 77.5,338.5C 77.67,339.822 77.3366,340.989 76.5,342C 70,344.167 63.5,346.333 57,348.5C 55.8315,347.991 54.9981,347.158 54.5,346C 61.3042,343.569 67.9709,341.069 74.5,338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eeeffa",
    d: "M 1114.5,337.5 C 1122.1,340.032 1129.76,342.365 1137.5,344.5C 1137.5,345.833 1137.5,347.167 1137.5,348.5C 1136.32,348.281 1135.32,348.614 1134.5,349.5C 1135.72,351.839 1135.72,354.172 1134.5,356.5C 1133.83,356.167 1133.17,355.833 1132.5,355.5C 1131.79,352.634 1131.13,349.8 1130.5,347C 1125.24,344.859 1119.91,343.026 1114.5,341.5C 1114.5,340.167 1114.5,338.833 1114.5,337.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9797e0",
    d: "M 432.5,338.5 C 431.089,340.914 429.089,342.581 426.5,343.5C 427.911,341.086 429.911,339.419 432.5,338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7fbfd",
    d: "M 86.5,345.5 C 89.694,345.176 90.694,346.342 89.5,349C 80.7517,352.472 72.0851,356.138 63.5,360C 60.5598,360.886 59.5598,360.052 60.5,357.5C 69.3536,353.671 78.0202,349.671 86.5,345.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9897e0",
    d: "M 423.5,346.5 C 422.089,348.914 420.089,350.581 417.5,351.5C 418.911,349.086 420.911,347.419 423.5,346.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1d8f4",
    d: "M 698.5,350.5 C 695.145,350.091 692.145,350.758 689.5,352.5C 689.5,351.5 689.5,350.5 689.5,349.5C 692.713,349.19 695.713,349.523 698.5,350.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f3fb",
    d: "M 1110.5,353.5 C 1119.33,352.162 1122.83,355.829 1121,364.5C 1119.54,366.96 1117.71,369.127 1115.5,371C 1124.03,373.988 1127.7,370.821 1126.5,361.5C 1127.5,361.5 1128.5,361.5 1129.5,361.5C 1130.51,367.291 1128.84,372.124 1124.5,376C 1116.19,376.183 1108.85,373.516 1102.5,368C 1104.72,365.329 1105.89,362.162 1106,358.5C 1107.06,356.341 1108.56,354.674 1110.5,353.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dedff5",
    d: "M 412.5,355.5 C 413.209,356.404 414.209,356.737 415.5,356.5C 414.292,357.782 412.958,357.782 411.5,356.5C 411.624,355.893 411.957,355.56 412.5,355.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d6ebf9",
    d: "M 787.5,355.5 C 788.751,356.472 788.418,357.139 786.5,357.5C 785.584,357.457 784.917,357.124 784.5,356.5C 785.791,356.737 786.791,356.404 787.5,355.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b5b5e9",
    d: "M 1045.5,355.5 C 1045.57,357.027 1044.91,358.027 1043.5,358.5C 1043.43,356.973 1044.09,355.973 1045.5,355.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6267d0",
    d: "M 1111.5,356.5 C 1118.21,357.056 1120.04,360.389 1117,366.5C 1112.58,370.544 1109.41,369.71 1107.5,364C 1107.67,362.833 1107.83,361.667 1108,360.5C 1109.38,359.295 1110.54,357.962 1111.5,356.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b4b5e8",
    d: "M 1043.5,358.5 C 1043.57,360.027 1042.91,361.027 1041.5,361.5C 1041.43,359.973 1042.09,358.973 1043.5,358.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f9fd",
    d: "M 76.5,361.5 C 86.6219,359.956 91.9552,364.29 92.5,374.5C 95.3388,372.58 98.3388,370.913 101.5,369.5C 102.287,370.242 102.953,371.075 103.5,372C 94.3313,377.752 84.998,383.252 75.5,388.5C 72.9211,387.112 72.9211,385.612 75.5,384C 67.6536,380.776 65.487,375.276 69,367.5C 71.4784,365.361 73.9784,363.361 76.5,361.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#46a4e6",
    d: "M 77.5,365.5 C 87.8069,364.624 90.8069,368.79 86.5,378C 83.6568,379.517 80.8234,381.017 78,382.5C 68.2302,377.142 68.0636,371.475 77.5,365.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f4fb",
    d: "M 1096.5,376.5 C 1098.2,376.34 1099.87,376.506 1101.5,377C 1105.83,379.833 1110.17,382.667 1114.5,385.5C 1115.85,384.05 1117.52,383.383 1119.5,383.5C 1119.58,384.93 1119.25,386.264 1118.5,387.5C 1120.13,388.99 1121.79,390.49 1123.5,392C 1121.32,394.667 1118.98,394.501 1116.5,391.5C 1115.33,392.491 1114.17,393.491 1113,394.5C 1111.94,394.37 1111.11,393.87 1110.5,393C 1111.76,391.663 1112.26,390.163 1112,388.5C 1108.17,386 1104.33,383.5 1100.5,381C 1099.5,380.333 1098.5,380.333 1097.5,381C 1096.69,382.706 1095.36,383.539 1093.5,383.5C 1093.15,380.547 1094.15,378.213 1096.5,376.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#43a3e6",
    d: "M 304.5,556.5 C 287.833,556.5 271.167,556.5 254.5,556.5C 208.207,551.847 165.541,536.847 126.5,511.5C 157.282,504.844 188.115,498.51 219,492.5C 214.596,463.076 209.429,433.742 203.5,404.5C 203.833,404.167 204.167,403.833 204.5,403.5C 253.525,430.861 302.859,431.361 352.5,405C 359.516,400.826 366.183,396.159 372.5,391C 409.114,387.581 445.781,384.748 482.5,382.5C 484.94,410.173 487.107,437.84 489,465.5C 438.871,518.647 377.371,548.98 304.5,556.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5d63cf",
    d: "M 727.5,383.5 C 761.23,385.243 794.897,387.743 828.5,391C 835.505,397.168 843.171,402.334 851.5,406.5C 851.821,408.048 852.821,408.715 854.5,408.5C 901.847,430.665 948.514,429.332 994.5,404.5C 995.338,404.842 995.672,405.508 995.5,406.5C 991.035,434.293 986.035,461.959 980.5,489.5C 979.876,489.917 979.543,490.584 979.5,491.5C 979.747,492.713 980.414,493.38 981.5,493.5C 1011.62,498.658 1041.62,504.325 1071.5,510.5C 1071.83,511.167 1072.17,511.833 1072.5,512.5C 1033.78,537.517 991.451,552.183 945.5,556.5C 928.833,556.5 912.167,556.5 895.5,556.5C 851.593,552.42 810.927,538.753 773.5,515.5C 773.027,514.094 772.027,513.427 770.5,513.5C 761.21,507.847 752.21,501.681 743.5,495C 732.368,485.536 721.534,475.703 711,465.5C 712.942,439.531 715.109,413.531 717.5,387.5C 718.434,386.432 718.768,385.099 718.5,383.5C 721.5,383.5 724.5,383.5 727.5,383.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bbbdeb",
    d: "M 727.5,383.5 C 724.5,383.5 721.5,383.5 718.5,383.5C 718.768,385.099 718.434,386.432 717.5,387.5C 717.5,385.833 717.5,384.167 717.5,382.5C 721.042,382.187 724.375,382.521 727.5,383.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f4fb",
    d: "M 1088.5,389.5 C 1099.77,388.362 1105.6,393.362 1106,404.5C 1101.66,413.669 1095.16,415.669 1086.5,410.5C 1085.48,409.998 1085.31,409.332 1086,408.5C 1090.02,403.979 1093.86,399.312 1097.5,394.5C 1088.74,390.913 1084.07,393.913 1083.5,403.5C 1082.5,403.5 1081.5,403.5 1080.5,403.5C 1080.21,397.125 1082.88,392.459 1088.5,389.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6369d1",
    d: "M 1099.5,396.5 C 1102.8,399.665 1103.3,403.332 1101,407.5C 1098.29,410.408 1095.13,411.075 1091.5,409.5C 1090.42,408.635 1090.25,407.635 1091,406.5C 1094.08,403.321 1096.91,399.988 1099.5,396.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7d9f3",
    d: "M 994.5,404.5 C 995.302,403.115 995.969,403.282 996.5,405C 996.43,405.765 996.097,406.265 995.5,406.5C 995.672,405.508 995.338,404.842 994.5,404.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aeace7",
    d: "M 851.5,406.5 C 852.71,406.932 853.71,407.599 854.5,408.5C 852.821,408.715 851.821,408.048 851.5,406.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f4fc",
    d: "M 789.5,431.5 C 792.462,431.117 793.462,432.117 792.5,434.5C 796.153,435.323 799.32,436.989 802,439.5C 802.494,441.134 802.66,442.801 802.5,444.5C 814.083,444.211 816.917,448.877 811,458.5C 808,462.167 805,465.833 802,469.5C 801.075,468.953 800.242,468.287 799.5,467.5C 803,462.5 806.5,457.5 810,452.5C 810.711,450.633 810.211,449.133 808.5,448C 806.305,446.627 803.971,446.294 801.5,447C 797.784,451.048 794.45,455.382 791.5,460C 789.924,460.388 788.591,459.888 787.5,458.5C 791.192,453.975 794.692,449.308 798,444.5C 798.626,440.115 796.626,437.781 792,437.5C 787.019,441.823 782.686,446.823 779,452.5C 777.978,451.646 777.145,450.646 776.5,449.5C 780.858,443.482 785.191,437.482 789.5,431.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f3fb",
    d: "M 821.5,457.5 C 836.051,456.634 840.884,462.968 836,476.5C 827.41,485.13 820.076,484.13 814,473.5C 813.138,466.545 815.638,461.212 821.5,457.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2f8fd",
    d: "M 353.5,459.5 C 356.091,460.254 357.924,461.921 359,464.5C 361.262,461.903 363.095,462.07 364.5,465C 362.777,465.523 361.444,466.523 360.5,468C 362.65,472.157 364.816,476.323 367,480.5C 368.851,483.064 370.684,483.064 372.5,480.5C 374.968,482.991 374.302,484.824 370.5,486C 369.167,486.667 367.833,486.667 366.5,486C 362.869,481.243 359.869,476.076 357.5,470.5C 355.997,469.948 354.331,469.948 352.5,470.5C 352.383,468.516 353.05,466.85 354.5,465.5C 352.826,463.57 352.493,461.57 353.5,459.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6066d0",
    d: "M 824.5,460.5 C 834.371,461.574 836.871,466.574 832,475.5C 827.594,479.423 823.261,479.423 819,475.5C 816.607,469.027 818.441,464.027 824.5,460.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1f1fb",
    d: "M 847.5,467.5 C 849.343,468.246 850.676,469.579 851.5,471.5C 855.401,470.038 859.068,470.538 862.5,473C 864.282,475.243 864.782,477.743 864,480.5C 861.667,486.167 859.333,491.833 857,497.5C 855.701,496.91 854.868,495.91 854.5,494.5C 856.5,489.167 858.5,483.833 860.5,478.5C 859.286,475.123 856.786,473.457 853,473.5C 851.774,473.645 850.607,473.978 849.5,474.5C 846.855,479.26 844.688,484.26 843,489.5C 841.989,490.337 840.822,490.67 839.5,490.5C 841.315,482.536 843.982,474.87 847.5,467.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ededf9",
    d: "M 874.5,468.5 C 875.833,468.5 877.167,468.5 878.5,468.5C 878.465,474.024 876.799,474.691 873.5,470.5C 873.863,469.817 874.196,469.15 874.5,468.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2f8fd",
    d: "M 340.5,471.5 C 343.187,471.336 345.854,471.503 348.5,472C 349.731,473.183 349.731,474.349 348.5,475.5C 344.547,473.853 341.047,474.52 338,477.5C 337.333,478.833 337.333,480.167 338,481.5C 342.42,481.976 346.92,482.143 351.5,482C 356.778,486.158 356.778,490.491 351.5,495C 347.637,496.354 343.637,496.854 339.5,496.5C 339.5,495.5 339.5,494.5 339.5,493.5C 342.518,493.665 345.518,493.498 348.5,493C 352.674,491.492 353.341,489.159 350.5,486C 345.833,485.667 341.167,485.333 336.5,485C 333.793,483.136 332.959,480.636 334,477.5C 336.063,475.266 338.229,473.266 340.5,471.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5fafd",
    d: "M 293.5,473.5 C 294.5,473.5 295.5,473.5 296.5,473.5C 296.5,475.833 296.5,478.167 296.5,480.5C 298.167,480.5 299.833,480.5 301.5,480.5C 301.5,481.5 301.5,482.5 301.5,483.5C 299.833,483.5 298.167,483.5 296.5,483.5C 295.479,489.13 295.313,494.796 296,500.5C 297.333,501.833 298.667,501.833 300,500.5C 300.684,501.784 300.517,502.951 299.5,504C 293.134,505.346 290.467,502.68 291.5,496C 292.04,491.511 292.374,487.011 292.5,482.5C 291.167,482.5 289.833,482.5 288.5,482.5C 288.5,481.5 288.5,480.5 288.5,479.5C 290.167,479.5 291.833,479.5 293.5,479.5C 293.5,477.5 293.5,475.5 293.5,473.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f4fb",
    d: "M 885.5,473.5 C 886.5,473.5 887.5,473.5 888.5,473.5C 888.5,475.833 888.5,478.167 888.5,480.5C 889.833,480.5 891.167,480.5 892.5,480.5C 892.762,481.978 892.429,483.311 891.5,484.5C 890.264,483.754 888.93,483.421 887.5,483.5C 886.398,489.448 885.731,495.448 885.5,501.5C 890.952,501.703 891.452,502.703 887,504.5C 884.966,504.646 883.299,503.98 882,502.5C 881.729,495.788 882.229,489.122 883.5,482.5C 882.5,482.5 881.5,482.5 880.5,482.5C 880.5,481.5 880.5,480.5 880.5,479.5C 881.833,479.5 883.167,479.5 884.5,479.5C 884.517,477.435 884.85,475.435 885.5,473.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0f0fa",
    d: "M 872.5,476.5 C 874.346,476.222 875.68,476.889 876.5,478.5C 874.569,485.128 872.736,491.795 871,498.5C 870.29,499.973 869.124,500.64 867.5,500.5C 868.846,492.447 870.513,484.447 872.5,476.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1f8fd",
    d: "M 314.5,478.5 C 323.67,477.558 328.67,481.558 329.5,490.5C 323.597,491.271 317.763,492.271 312,493.5C 312.796,499.585 316.296,501.752 322.5,500C 324.369,498.398 326.369,497.398 328.5,497C 329.451,497.718 329.617,498.551 329,499.5C 323.174,504.082 317.008,504.582 310.5,501C 304.146,491.944 305.479,484.444 314.5,478.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efeffa",
    d: "M 934.5,477.5 C 935.5,477.5 936.5,477.5 937.5,477.5C 937.649,478.552 937.483,479.552 937,480.5C 933.816,481.842 931.983,484.176 931.5,487.5C 932.131,492.925 933.131,498.258 934.5,503.5C 933.167,503.5 931.833,503.5 930.5,503.5C 928.835,495.506 927.168,487.506 925.5,479.5C 926.833,479.5 928.167,479.5 929.5,479.5C 929.351,480.552 929.517,481.552 930,482.5C 931.707,480.963 933.207,479.296 934.5,477.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#48a5e6",
    d: "M 314.5,481.5 C 320.412,480.609 324.079,482.942 325.5,488.5C 320.5,489.167 315.5,489.833 310.5,490.5C 310.482,486.871 311.816,483.871 314.5,481.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f4fb",
    d: "M 903.5,481.5 C 917.131,480.295 922.298,486.295 919,499.5C 915.867,505.327 911.034,507.493 904.5,506C 897.526,502.551 895.026,497.051 897,489.5C 898.305,486.039 900.471,483.372 903.5,481.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6066d0",
    d: "M 905.5,484.5 C 914.186,484.508 917.686,488.841 916,497.5C 913.565,502.224 909.731,503.724 904.5,502C 898.864,495.672 899.198,489.839 905.5,484.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#abaee6",
    d: "M 980.5,489.5 C 980.433,490.959 980.766,492.292 981.5,493.5C 980.414,493.38 979.747,492.713 979.5,491.5C 979.543,490.584 979.876,489.917 980.5,489.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bcbdeb",
    d: "M 1071.5,510.5 C 1074.85,510.345 1075.19,511.012 1072.5,512.5C 1072.17,511.833 1071.83,511.167 1071.5,510.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b5b5e9",
    d: "M 770.5,513.5 C 772.027,513.427 773.027,514.094 773.5,515.5C 771.973,515.573 770.973,514.906 770.5,513.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevops);
export default __webpack_public_path__ + "static/media/devops.9333b641c2d47f32e02a4193fa38c326.svg";
export { ForwardRef as ReactComponent };